import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-featured px-4 sm:px-0 pb-10"
}
const _hoisted_2 = {
  key: 0,
  class: "sf-heading sf-category-title text-xl md:text-2xl font-bold"
}
const _hoisted_3 = {
  key: 1,
  class: "sf-featured__subtitle text-sm mt-1"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sf-skeleton w-full h-40 sf-radius" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "sf-skeleton h-4 mt-2 w-3/4" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { computed } from 'vue'
import { Pagination, FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import { categories } from '@/global/state/GlobalState'
import { FeaturedProductsSection, storefrontTemplate } from '@/global/state/StorefrontState'
import StoreProductCard from '../StoreProductCard.vue'
import StoreProductGrid from '../StoreProductGrid.vue'

/* global defineProps, defineEmits */

export default /*#__PURE__*/_defineComponent({
  __name: 'FeaturedProductsSection',
  props: {
    section: {}
  },
  emits: ['open-product'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const modules = [Pagination, FreeMode]
const template = storefrontTemplate
const style = computed(() => props.section.settings?.style ?? 'carousel')
const isLoadingProducts = computed(() => !categories.value && (props.section.settings?.productIds?.length ?? 0) > 0)

/** Resolve the configured ids against the cached catalog, keeping the configured order. */
const products = computed<any[]>(() => {
  const ids: number[] = props.section.settings?.productIds ?? []
  if (!ids.length || !categories.value) return []
  const byId = new Map<number, any>()
  categories.value.forEach((category: any) => {
    (category.products || []).forEach((product: any) => {
      if (!byId.has(Number(product.id))) byId.set(Number(product.id), product)
    })
  })
  return ids
    .map((id) => byId.get(Number(id)))
    .filter((product: any) => product && product.isActive !== false && !product.isDeleted)
})

const breakpoints = computed(() => {
  switch (template.value) {
    case 'grid':
    case 'dark':
      return { 0: { slidesPerView: 2.2, spaceBetween: 12 }, 768: { slidesPerView: 3.2, spaceBetween: 16 }, 1024: { slidesPerView: 4, spaceBetween: 20 } }
    case 'showcase':
      return { 0: { slidesPerView: 1.15, spaceBetween: 16 }, 768: { slidesPerView: 2.2, spaceBetween: 24 }, 1024: { slidesPerView: 3, spaceBetween: 28 } }
    case 'minimal':
      return { 0: { slidesPerView: 1.1, spaceBetween: 24 }, 768: { slidesPerView: 2, spaceBetween: 48 }, 1024: { slidesPerView: 3, spaceBetween: 56 } }
    default:
      return { 0: { slidesPerView: 1.1, spaceBetween: 16 }, 768: { slidesPerView: 2, spaceBetween: 32 }, 1024: { slidesPerView: 2.5, spaceBetween: 32 } }
  }
})

return (_ctx: any,_cache: any) => {
  return (products.value.length || isLoadingProducts.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_ctx.section.settings.title || _ctx.section.settings.subtitle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["pb-5", { 'text-center': _unref(template) === 'minimal' }])
            }, [
              (_ctx.section.settings.title)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(_ctx.section.settings.title), 1))
                : _createCommentVNode("", true),
              (_ctx.section.settings.subtitle)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.section.settings.subtitle), 1))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (isLoadingProducts.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["sf-product-grid animate-pulse", `sf-product-grid--${_unref(template)}`])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4], (i) => {
                return _createElementVNode("div", { key: i }, _hoisted_6)
              }), 64))
            ], 2))
          : (style.value === 'carousel')
            ? (_openBlock(), _createBlock(_unref(Swiper), {
                key: 2,
                "slides-per-view": 1.2,
                "space-between": 16,
                pagination: true,
                "free-mode": true,
                modules: modules,
                breakpoints: breakpoints.value,
                class: "pb-10 sf-featured__carousel"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      key: product.id,
                      class: "h-auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(StoreProductCard, {
                          product: product,
                          onSelect: _cache[0] || (_cache[0] = (p) => emit('open-product', p))
                        }, null, 8, ["product"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["breakpoints"]))
            : (_openBlock(), _createBlock(StoreProductGrid, {
                key: 3,
                products: products.value,
                onSelect: _cache[1] || (_cache[1] = (p) => emit('open-product', p))
              }, null, 8, ["products"]))
      ]))
    : _createCommentVNode("", true)
}
}

})